import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

type UniversalSearchHeaderProps = {
  isLoading: boolean;
  searchTerm: string;
  totalFoundBySearch: number;
};

const NoItemsFoundHeaderV2 = () => {
  const { t2 } = useTranslation('catalogRegistry');
  const { hed, dek } = t2('searchHeader', 'noSearchResults');
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      rowGap={5}
    >
      <TextV2 typographyVariant={['HedMobile32', null, null, 'Hed56']}>{hed}</TextV2>
      <TextV2 typographyVariant={['hed1', null, null, 'hed4']}>{dek}</TextV2>
    </Flex>
  );
};

export const MultipleItemsFoundHeaderV2 = ({ searchTerm, totalFoundBySearch }: Omit<UniversalSearchHeaderProps, 'isLoading'>) => {
  const { t } = useTranslation('catalogRegistry');
  const tSearchHeader = t('searchHeader');
  const message = tSearchHeader.itemsFoundV2({
    pluralization: totalFoundBySearch > 1 ? 's' : '',
    searchTerm,
    count: totalFoundBySearch,
  });
  return <TextV2 typographyVariant={['HedMobile32', null, null, 'Hed56']}>{message}</TextV2>;
};
export const UniversalSearchHeader = (props: UniversalSearchHeaderProps) => {
  const { searchTerm, totalFoundBySearch } = props;

  const noResultsFound = totalFoundBySearch === 0;

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      rowGap={3}
      width={'100%'}
      paddingX={6}
      marginBottom={noResultsFound ? undefined : 5}
    >
      {noResultsFound ? (
        <NoItemsFoundHeaderV2 />
      ) : (
        <MultipleItemsFoundHeaderV2
          searchTerm={searchTerm}
          totalFoundBySearch={totalFoundBySearch}
        />
      )}
    </Flex>
  );
};
